import { GetterTree } from 'vuex';
import { RegionState } from './types';
import { RootState } from '@/store/types';

export const getters: GetterTree<RegionState, RootState> = {};
